import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { IUser, UserActionTypes } from "../models";
import { GET_USER } from "../types";

export default () => async (dispatch: Dispatch<UserActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.get<IUser>("/user");
        dispatch({
            type: GET_USER,
            payload: res,
        });
    } catch (error) {
        dispatch(showNotification(error.toString(), "warning"));
    }
};